import { CHANNEL_META, PROGRAM_CARD_META } from "../../ReceiptPage/constants/receipt-status-mapping"

// Channels and programs in the vocabulary the Receipt lookups table already speaks, so both
// Deflect screens name them the same way. Colours follow the prototype's chart palette.
export const CHANNEL_COLORS = {
  banking_app: "#225AEA",
  call_center: "#661AC6",
  mastercom: "#16895A"
}

// How many channels a lookup can arrive on: the rows every per-channel skeleton draws.
export const CHANNEL_COUNT = Object.keys(CHANNEL_COLORS).length

export const channelLabel = (channel) => CHANNEL_META[channel]?.label || channel

export const programLabel = (program) => PROGRAM_CARD_META[program]?.label || program

export const programIcon = (program) => PROGRAM_CARD_META[program]?.iconType

export const PROGRAM_OPTIONS = Object.entries(PROGRAM_CARD_META).map(([id, meta]) => ({
  id,
  name: meta.label
}))
